module.exports = {"331081001":"太平街道","331081002":"城东街道","331081003":"城西街道","331081004":"城北街道","331081005":"横峰街道","331081100":"泽国镇","331081101":"大溪镇","331081102":"松门镇","331081103":"箬横镇","331081104":"新河镇","331081105":"石塘镇","331081106":"滨海镇","331081107":"温峤镇","331081108":"城南镇","331081109":"石桥头镇","331081110":"坞根镇","331081400":"东部新区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/331081.json
// module id = 1023
// module chunks = 0